/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type StarCollectionMutationVariables = Types.Exact<{
  collectionId: Types.Scalars["CollectionId"]["input"];
  starred: Types.Scalars["Boolean"]["input"];
}>;

export type StarCollectionMutation = {
  readonly __typename: "Mutation";
  readonly starCollection: {
    readonly __typename: "Collection";
    readonly id: c.CollectionId;
    readonly starredByViewer: boolean;
  };
};

export const StarCollectionDocument = /*#__PURE__*/ gql`
  mutation starCollection($collectionId: CollectionId!, $starred: Boolean!) {
    starCollection(collectionId: $collectionId, starred: $starred) {
      id
      starredByViewer
    }
  }
`;
export type StarCollectionMutationFn = Apollo.MutationFunction<
  StarCollectionMutation,
  StarCollectionMutationVariables
>;

/**
 * __useStarCollectionMutation__
 *
 * To run a mutation, you first call `useStarCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStarCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [starCollectionMutation, { data, loading, error }] = useStarCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      starred: // value for 'starred'
 *   },
 * });
 */
export function useStarCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StarCollectionMutation,
    StarCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StarCollectionMutation,
    StarCollectionMutationVariables
  >(StarCollectionDocument, options);
}
export type StarCollectionMutationHookResult = ReturnType<
  typeof useStarCollectionMutation
>;
export type StarCollectionMutationResult =
  Apollo.MutationResult<StarCollectionMutation>;
export type StarCollectionMutationOptions = Apollo.BaseMutationOptions<
  StarCollectionMutation,
  StarCollectionMutationVariables
>;
